/* ChiQWorld theme script — small, dependency-free, progressive enhancement only.
   Everything important is server-rendered HTML; this file adds filtering, the gallery viewer,
   enquiry attribution and consent-aware event publishing. */
(function () {
  "use strict";
  var d = document, w = window;
  var reduced = w.matchMedia && w.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };

  /* ---- Analytics: publish to Shopify Customer Events (consent handled by Shopify's pixel sandbox) ---- */
  function track(name, data) {
    try {
      if (w.Shopify && w.Shopify.analytics && typeof w.Shopify.analytics.publish === "function") {
        w.Shopify.analytics.publish("chiq_" + name, data || {});
      }
    } catch (e) { /* never break the page for analytics */ }
  }
  w.ChiQ = { track: track };

  /* ---- Header ---- */
  var hdr = $("[data-header]");
  if (hdr) {
    var onScroll = function () { hdr.classList.toggle("is-compact", w.scrollY > 24); };
    w.addEventListener("scroll", onScroll, { passive: true }); onScroll();
    var burger = $("[data-menu-toggle]", hdr);
    if (burger) {
      var setOpen = function (open) {
        burger.setAttribute("aria-expanded", String(open));
        hdr.classList.toggle("is-open", open);
        d.documentElement.classList.toggle("menu-open", open);   // locks page scroll behind the menu
        var m = $("#" + burger.getAttribute("aria-controls")); if (m) m.hidden = !open;
      };
      $$("#" + burger.getAttribute("aria-controls") + " a").forEach(function (a) { a.addEventListener("click", function () { setOpen(false); }); });
      w.matchMedia("(min-width: 1181px)").addEventListener("change", function (e) { if (e.matches) setOpen(false); });
      burger.addEventListener("click", function () { setOpen(burger.getAttribute("aria-expanded") !== "true"); });
      d.addEventListener("keydown", function (e) { if (e.key === "Escape" && hdr.classList.contains("is-open")) { setOpen(false); burger.focus(); } });
    }
  }

  /* ---- Page context (set in layout/theme.liquid) ---- */
  var ctx = {};
  try { ctx = JSON.parse(($("#chiq-ctx") || {}).textContent || "{}"); } catch (e) { ctx = {}; }

  /* ---- WhatsApp: every link opens a chat pre-filled with what the visitor is looking at ---- */
  if (ctx.wa) {
    $$("[data-whatsapp]").forEach(function (a) {
      var href = a.getAttribute("href") || "";
      if (!/wa\.me\//.test(href)) return;
      a.setAttribute("href", href.split("?")[0] + "?text=" + encodeURIComponent(ctx.wa));
    });
  }

  /* ---- Area units: m² / ft², remembered per visitor (US English browsers start in ft²) ---- */
  var UNIT_KEY = "chiq_unit", FT = 10.7639;
  var lang = (d.documentElement.lang || "en").slice(0, 2);
  var fmtN = function (n, dec) { return n.toLocaleString("en-US", { maximumFractionDigits: dec ? 1 : 0 }); };
  var parseN = function (t) { return parseFloat(lang === "es" ? t.replace(/\./g, "").replace(",", ".") : t.replace(/,/g, "")); };
  function getUnit() {
    try { var u = w.localStorage.getItem(UNIT_KEY); if (u === "m2" || u === "ft2") return u; } catch (e) {}
    return (navigator.language || "").toLowerCase() === "en-us" ? "ft2" : "m2";
  }
  function applyUnit(u) {
    $$(".area[data-m2]").forEach(function (el) {
      if (!el.hasAttribute("data-orig")) el.setAttribute("data-orig", el.textContent);
      var orig = el.getAttribute("data-orig");
      if (u === "m2") { el.textContent = orig; return; }
      var m = parseFloat(el.getAttribute("data-m2")); if (isNaN(m)) return;
      var ft = fmtN(m * FT) + " ft²";
      el.textContent = el.hasAttribute("data-both") ? ft + " (" + orig.split(" (")[0] + ")" : ft;
    });
    $$("[data-area-scan] td").forEach(function (td) {
      if (!td.hasAttribute("data-orig")) td.setAttribute("data-orig", td.textContent);
      var orig = td.getAttribute("data-orig");
      td.textContent = u === "m2" ? orig : orig.replace(/(\d[\d.,]*)\s?m²/g, function (_, n) { var v = parseN(n); return isNaN(v) ? _ : fmtN(v * FT) + " ft²"; });
    });
    $$("[data-units] [data-unit]").forEach(function (b) { b.setAttribute("aria-pressed", String(b.getAttribute("data-unit") === u)); });
  }
  if ($(".area[data-m2]") || $("[data-area-scan]")) {
    $$("[data-units]").forEach(function (g) { g.hidden = false; });
    var unit = getUnit(); if (unit !== "m2") applyUnit(unit); else applyUnit("m2");
    d.addEventListener("click", function (e) {
      var b = e.target.closest("[data-units] [data-unit]"); if (!b) return;
      var u = b.getAttribute("data-unit");
      try { w.localStorage.setItem(UNIT_KEY, u); } catch (err) {}
      applyUnit(u); track("unit_switch", { unit: u });
    });
  }

  /* ---- New homes sign-up: tag the chosen rhythm, confirm after Shopify's redirect ---- */
  $$("form.alert__form").forEach(function (form) {
    form.addEventListener("submit", function () {
      var pick = $("input[name='alert_interest']:checked", form), tags = $("[data-alert-tags]", form);
      var v = pick ? pick.value : "any";
      if (tags && v !== "any") tags.value = tags.value + ",interest-" + v;
      track("alert_signup", { interest: v, page: w.location.pathname });
    });
  });

  /* ---- Journal: load more articles in place (pagination stays as the no-JS fallback) ---- */
  $$("[data-jmore]").forEach(function (btn) {
    var grid = $("[data-jgrid]"), pag = $("[data-jpag]");
    if (!grid) return;
    if (pag) pag.hidden = true;
    var label = btn.textContent;
    btn.addEventListener("click", function () {
      var url = btn.getAttribute("data-jmore"); if (!url) return;
      btn.disabled = true; btn.textContent = btn.getAttribute("data-loading") || label;
      fetch(url, { credentials: "same-origin" }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var cards = $$("[data-jgrid] .jcard", doc), first = null;
        cards.forEach(function (c) { c.removeAttribute("data-reveal"); var n = d.importNode(c, true); grid.appendChild(n); if (!first) first = n; });
        var next = $("[data-jmore]", doc);
        if (next) { btn.setAttribute("data-jmore", next.getAttribute("data-jmore")); btn.disabled = false; btn.textContent = label; }
        else btn.parentNode.remove();
        if (first) { first.setAttribute("tabindex", "-1"); first.focus({ preventScroll: true }); }
        if (w.history.replaceState) w.history.replaceState(null, "", url);
        track("journal_more", { page: url });
      }).catch(function () { w.location.href = url; });
    });
  });

  /* ---- Article: reading progress, table of contents, copy link ---- */
  (function () {
    var art = $("[data-article]"), prose = $("[data-prose]");
    if (!art || !prose) return;
    var bar = $("[data-readbar]");
    if (bar) {
      var onScroll = function () {
        var r = prose.getBoundingClientRect(), h = prose.offsetHeight - w.innerHeight * 0.6;
        var p = h > 0 ? Math.min(1, Math.max(0, -r.top / h)) : 0;
        bar.style.transform = "scaleX(" + p + ")";
      };
      w.addEventListener("scroll", onScroll, { passive: true }); onScroll();
    }
    var heads = $$("h2", prose).filter(function (h) { return h.textContent.trim().length > 1; });
    if (heads.length >= 3) {
      var used = {};
      heads.forEach(function (h, i) {
        if (!h.id) {
          var id = h.textContent.trim().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "").slice(0, 60) || "section-" + (i + 1);
          while (used[id]) id += "-" + (i + 1);
          used[id] = 1; h.id = id;
        }
      });
      $$("[data-toc-list]").forEach(function (ol) {
        heads.forEach(function (h) { var li = d.createElement("li"), a = d.createElement("a"); a.href = "#" + h.id; a.textContent = h.textContent.trim(); li.appendChild(a); ol.appendChild(li); });
      });
      $$("[data-toc-inline],[data-toc-side]").forEach(function (el) { el.hidden = false; });
      var links = $$("[data-toc-side] a");
      if ("IntersectionObserver" in w && links.length) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (!e.isIntersecting) return;
            links.forEach(function (a) { a.classList.toggle("is-current", a.getAttribute("href") === "#" + e.target.id); });
          });
        }, { rootMargin: "0px 0px -70% 0px" });
        heads.forEach(function (h) { io.observe(h); });
      }
    }
    $$("[data-copy]").forEach(function (b) {
      b.addEventListener("click", function () {
        var done = function () { var t0 = b.textContent; b.textContent = b.getAttribute("data-copied"); setTimeout(function () { b.textContent = t0; }, 2000); };
        if (navigator.clipboard) navigator.clipboard.writeText(b.getAttribute("data-copy")).then(done, function () {});
        track("share", { method: "copy" });
      });
    });
    $$("[data-share]").forEach(function (a) { a.addEventListener("click", function () { track("share", { method: a.getAttribute("data-share") }); }); });
  })();

  /* ---- Smart site search ----
     One index per language (search?view=index), loaded on first use and kept for the session.
     Understands bedrooms, budget, rhythm (coast / mountain / lake), renting and FRESH in English and Spanish,
     tolerates small typos and accents, and answers FAQ questions directly. */
  (function () {
    var root = $("[data-sx]"); if (!root) return;
    var input = $("[data-sx-input]", root), list = $("[data-sx-list]", root), form = $("[data-sx-form]", root);
    var L = {}; try { L = JSON.parse(($("#sx-i18n") || {}).textContent || "{}"); } catch (e) {}
    var fmt = function (s, o) { return String(s || "").replace(/\{(\w+)\}/g, function (m, k) { return o && o[k] != null ? o[k] : m; }); };
    var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]; }); };
    var norm = function (s) { return String(s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9$.,+ ]+/g, " ").replace(/\s+/g, " ").trim(); };
    var KEY = "chiq_sx_" + (d.documentElement.lang || "en");
    var items = null, loading = null, lastFocus = null, active = -1, opts = [], timer = null;

    function load() {
      if (items) return Promise.resolve(items);
      if (loading) return loading;
      try { var c = w.sessionStorage.getItem(KEY); if (c) { items = JSON.parse(c); prep(); return Promise.resolve(items); } } catch (e) {}
      loading = fetch(root.getAttribute("data-index"), { credentials: "same-origin" }).then(function (r) { return r.text(); }).then(function (txt) {
        var data = JSON.parse(txt.replace(/,\s*\]/g, "]"));
        items = data.items || [];
        try { w.sessionStorage.setItem(KEY, JSON.stringify(items)); } catch (e) {}
        prep(); return items;
      });
      return loading;
    }
    function prep() {
      items.forEach(function (it) {
        it._n = norm(it.n); it._k = norm(it.k); it._x = norm(it.x);
        it._w = it._n.split(" ");
      });
    }

    /* Query understanding */
    var STOP = "a an the in on at of for with and or to near me my i im want looking home homes house houses property properties residence residences una un el la los las de del en con para y o cerca mi casa casas propiedad propiedades residencia residencias quiero busco".split(" ");
    var LIFE = {
      coast: "beach beaches coast coastal ocean sea seaside surf playa playas costa mar oceano surf pacific pacifico".split(" "),
      mountain: "mountain mountains hills highlands cool montana montanas sierra campana altos fresco".split(" "),
      lake: "lake lakefront lakeside lago gatun canal".split(" ")
    };
    var RENT = "rent rental renting rentals alquiler alquilar arriendo".split(" ");
    var FRESH = "fresh modular prefab prefabricated".split(" ");
    function parse(q) {
      var s = " " + norm(q) + " ", f = {};
      var m = s.match(/(?:under|below|max|maximum|up to|upto|less than|budget|hasta|menos de|maximo|bajo|presupuesto)\s*(?:usd|us)?\s*\$?\s*([\d][\d.,]*)\s*(k|m|mil|million|millon|millones)?/);
      if (!m) m = s.match(/\$\s*([\d][\d.,]*)\s*(k|m)?/) || s.match(/\b([\d]{2,4}(?:[.,]\d+)?)\s*(k|m)\b/);
      if (m) {
        var v = parseFloat(m[1].replace(/,/g, "").replace(/\.(?=\d{3}\b)/g, ""));
        var u = m[2] || "";
        if (/^k|mil$/.test(u)) v *= 1000; else if (/^m/.test(u)) v *= 1e6; else if (v < 10000) v *= 1000;
        if (v >= 20000) { f.max = v; s = s.replace(m[0], " "); }
      }
      var b = s.match(/\b(\d)\s*\+?\s*(?:bed|beds|bedroom|bedrooms|br|bd|bdr|hab|habs|habitacion|habitaciones|recamara|recamaras|dormitorio|dormitorios|cuarto|cuartos)\b/);
      if (b) { f.beds = +b[1]; s = s.replace(b[0], " "); }
      var toks = s.split(" ").filter(Boolean), rest = [];
      f.soft = [];
      toks.forEach(function (t) {
        var hit = false;
        Object.keys(LIFE).forEach(function (k) { if (LIFE[k].indexOf(t) > -1) { f.life = k; hit = true; } });
        if (RENT.indexOf(t) > -1) { f.rent = true; hit = true; }
        if (hit) f.soft.push(t);
        if (FRESH.indexOf(t) > -1) { f.fresh = true; }
        if (!hit && STOP.indexOf(t) === -1 && t.length > 1) rest.push(t.replace(/[.,$]/g, ""));
      });
      f.tokens = rest.filter(Boolean);
      f.structured = !!(f.max || f.beds || f.life || f.rent);
      return f;
    }

    function lev(a, b, max) {
      if (Math.abs(a.length - b.length) > max) return max + 1;
      var prev = [], cur, i, j;
      for (j = 0; j <= b.length; j++) prev[j] = j;
      for (i = 1; i <= a.length; i++) {
        cur = [i]; var best = i;
        for (j = 1; j <= b.length; j++) { cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1)); if (cur[j] < best) best = cur[j]; }
        if (best > max) return max + 1;
        prev = cur;
      }
      return prev[b.length];
    }
    function tokenScore(it, t) {
      var sc = 0;
      if (it._w.some(function (wd) { return wd.indexOf(t) === 0; })) sc = 6;
      else if (it._n.indexOf(t) > -1) sc = 4;
      if (it._k.indexOf(t) > -1) sc = Math.max(sc, 3);
      if (it._x.indexOf(t) > -1) sc = Math.max(sc, 2.5);
      if (!sc && t.length >= 4) {
        var max = t.length >= 7 ? 2 : 1;
        if (it._w.some(function (wd) { return wd.length >= 3 && lev(t, wd.slice(0, t.length + 1), max) <= max; })) sc = 3;
        else if ((it._k + " " + it._x).split(" ").some(function (wd) { return wd.length >= 4 && lev(t, wd, max) <= max; })) sc = 1.5;
      }
      return sc;
    }
    var BOOST = { r: 1.3, c: 1.25, g: 1.15, f: 1.1, p: 1, a: 0.95 };
    function search(q) {
      var f = parse(q), out = { f: f, groups: {} };
      var all = function (it) { return f.tokens.every(function (t) { return tokenScore(it, t) > 0; }); };
      var scored = [];
      items.forEach(function (it) {
        var s = 0;
        f.tokens.forEach(function (t) { s += tokenScore(it, t); });
        f.soft.forEach(function (t) { s += tokenScore(it, t) * 0.8; });
        if (f.life && it.l === f.life) s += 3;
        if (f.life && it._k.indexOf(f.life) > -1) s += 1;
        if (s > 0) scored.push({ it: it, s: s * (BOOST[it.t] || 1), all: all(it) });
      });
      var strict = scored.filter(function (x) { return x.all; });
      var pool = strict.length ? strict : scored;
      pool.sort(function (a, b) { return b.s - a.s; });
      out.best = {};
      pool.forEach(function (x) { (out.groups[x.it.t] = out.groups[x.it.t] || []).push(x.it); if (!out.best[x.it.t]) out.best[x.it.t] = x.s; });
      if (f.structured) {
        out.homes = items.filter(function (it) {
          if (it.t !== "r" || it.st === "sold") return false;
          if (f.max && (!it.p || it.p > f.max)) return false;
          if (f.beds && it.b < f.beds) return false;
          if (f.life && it.l !== f.life) return false;
          if (f.rent && !(it.ra || it.st === "for-sale-rent" || it.st === "rented")) return false;
          if (f.fresh && it.sy !== "fresh") return false;
          return true;
        }).sort(function (a, b) { return (a.p || 0) - (b.p || 0); });
      }
      return out;
    }

    /* Rendering */
    function fdate(s) { try { return s ? new Date(s + "T12:00:00").toLocaleDateString(d.documentElement.lang || "en", { year: "numeric", month: "long" }) : ""; } catch (e) { return s; } }
    function thumb(it) { return it.img ? '<img src="' + esc(it.img) + '" alt="" width="64" height="48" loading="lazy">' : '<span class="sx__ph" aria-hidden="true"></span>'; }
    function row(it, extra) {
      var sub = it.t === "r" ? [it.pd, it.b ? fmt(L.beds, { n: it.b }).replace("+", "") : "", it.s].filter(Boolean).join(" · ") : (it.t === "a" ? fdate(it.s) : (it.s || ""));
      return '<a class="sx__item" role="option" id="sx-o' + (opts.length) + '" href="' + esc(it.u) + '" data-sx-opt data-type="' + it.t + '">' + thumb(it) +
        '<span class="sx__txt"><span class="sx__n">' + esc(it.n) + (it.st === "sold" ? ' <em class="sx__tag">' + esc(L.status_sold) + '</em>' : "") + '</span>' +
        (sub ? '<span class="sx__s">' + esc(sub) + '</span>' : "") + (extra || "") + '</span></a>';
    }
    function snap(v) { return v <= 400000 ? 400000 : v <= 600000 ? 600000 : v <= 1000000 ? 1000000 : "all"; }
    function render(q) {
      opts = []; active = -1;
      if (!q) { renderEmpty(); return; }
      var r = search(q), h = "", f = r.f, count = 0;
      var add = function (html) { h += html; };
      var group = function (key, arr, n, fn) {
        if (!arr || !arr.length) return;
        add('<div class="sx__g" role="group" aria-label="' + esc(L["g_" + key]) + '"><p class="sx__gh">' + esc(L["g_" + key]) + "</p>");
        arr.slice(0, n).forEach(function (it) { add(fn ? fn(it) : row(it)); opts.push(1); count++; });
        add("</div>");
      };
      // Quick answer from the FAQ when the question matches well
      var faq = (r.groups.f || []).slice(0, 1);
      if (faq.length && f.tokens.length >= 2 && f.tokens.every(function (t) { return tokenScore(faq[0], t) > 0; })) {
        group("f", faq, 1, function (it) {
          return '<div class="sx__answer" role="option" id="sx-o' + opts.length + '" data-sx-opt tabindex="-1"><p class="sx__q">' + esc(it.n) + '</p><p class="sx__a">' + esc(it.x) + "</p></div>";
        });
      }
      if (r.homes) {
        var chips = [];
        if (f.beds) chips.push(fmt(L.beds, { n: f.beds }));
        if (f.max) chips.push(fmt(L.up_to, { amount: f.max >= 1e6 ? (f.max / 1e6).toFixed(f.max % 1e6 ? 1 : 0) + "M" : Math.round(f.max / 1000) + "k" }));
        if (f.life) chips.push(L["life_" + f.life]);
        if (f.rent) chips.push(L.rent);
        if (f.fresh) chips.push(L.fresh);
        var p = new URLSearchParams();
        if (f.life) p.set("life", f.life);
        if (f.beds) p.set("beds", Math.min(f.beds, 4));
        if (f.max) p.set("max", snap(f.max));
        var url = root.getAttribute("data-residences") + (p.toString() ? "?" + p.toString() : "");
        add('<div class="sx__g sx__homes" role="group" aria-label="' + esc(L.homes_match) + '"><p class="sx__gh">' + esc(L.homes_match) + ' <span class="sx__chips">' + chips.map(function (c) { return "<span>" + esc(c) + "</span>"; }).join("") + "</span></p>");
        r.homes.slice(0, 4).forEach(function (it) { add(row(it)); opts.push(1); count++; });
        if (!r.homes.length) add('<p class="sx__empty">' + esc(L.no_homes) + "</p>");
        add('<a class="sx__more" role="option" id="sx-o' + opts.length + '" data-sx-opt href="' + esc(url) + '">' + esc(r.homes.length ? L.see_all_homes : L.any_home) + " →</a></div>");
        opts.push(1);
      } else group("r", r.groups.r, 4);
      // Remaining groups ordered by their best match, so a strong article isn't buried under weak page hits.
      var N = { c: 3, g: 3, p: 4, a: 5 };
      ["c", "g", "p", "a"].sort(function (a, b) { return (r.best[b] || 0) - (r.best[a] || 0); }).forEach(function (k) { group(k, r.groups[k], N[k]); });
      if (!count) {
        add('<div class="sx__none"><p><strong>' + esc(fmt(L.no_results, { q: q })) + "</strong></p><p>" + esc(L.no_results_text) + '</p><a class="btn btn--primary btn--sm" href="' + esc(L.contact_url) + '">' + esc(L.contact) + "</a></div>");
      }
      add('<a class="sx__all" role="option" id="sx-o' + opts.length + '" data-sx-opt href="' + esc(form.getAttribute("action") + "?type=article,page&q=" + encodeURIComponent(q)) + '">' + esc(fmt(L.all_results, { q: q })) + " →</a>");
      opts.push(1);
      list.innerHTML = h;
      input.setAttribute("aria-expanded", "true");
      clearTimeout(timer); timer = setTimeout(function () { track("search", { term: q, results: count }); }, 900);
    }
    function renderEmpty() {
      var h = '<div class="sx__g"><p class="sx__gh">' + esc(L.suggest) + '</p><div class="sx__sugg">';
      for (var i = 1; i <= 6; i++) if (L["s" + i]) h += '<button type="button" class="chip" data-sx-q="' + esc(L["q" + i]) + '">' + esc(L["s" + i]) + "</button>";
      list.innerHTML = h + "</div></div>";
      input.setAttribute("aria-expanded", "false");
    }
    function setActive(i) {
      var els = $$("[data-sx-opt]", list); if (!els.length) return;
      active = (i + els.length) % els.length;
      els.forEach(function (el, n) { el.setAttribute("aria-selected", n === active ? "true" : "false"); });
      els[active].scrollIntoView({ block: "nearest" });
      input.setAttribute("aria-activedescendant", els[active].id || "");
    }

    function open(prefill) {
      lastFocus = d.activeElement;
      root.hidden = false; d.documentElement.classList.add("sx-open");
      if (prefill != null) input.value = prefill;
      input.focus(); input.select();
      if (!items) list.innerHTML = '<p class="sx__loading">' + esc(L.loading) + "</p>";
      load().then(function () { render(input.value.trim()); }).catch(function () { list.innerHTML = ""; });
      $$("[data-sx-open]").forEach(function (b) { b.setAttribute("aria-expanded", "true"); });
    }
    function close() {
      root.hidden = true; d.documentElement.classList.remove("sx-open");
      $$("[data-sx-open]").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    $$("[data-sx-open]").forEach(function (b) {
      b.addEventListener("click", function (e) { e.preventDefault(); open(); });
      b.addEventListener("pointerenter", function () { load().catch(function () {}); }, { once: true });
    });
    $$("[data-sx-close]", root).forEach(function (b) { b.addEventListener("click", close); });
    input.addEventListener("input", function () { var q = input.value.trim(); if (items) render(q); });
    input.addEventListener("keydown", function (e) {
      if (e.key === "ArrowDown") { e.preventDefault(); setActive(active + 1); }
      else if (e.key === "ArrowUp") { e.preventDefault(); setActive(active - 1); }
      else if (e.key === "Enter" && active > -1) {
        var el = $$("[data-sx-opt]", list)[active];
        if (el && el.href) { e.preventDefault(); track("search_select", { term: input.value.trim(), type: el.getAttribute("data-type") || "" }); w.location.href = el.href; }
      }
    });
    root.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { e.preventDefault(); close(); }
      if (e.key === "Tab") { // keep focus inside the dialog
        var f = $$("input:not([type=hidden]),button,a[href],[tabindex='0']", root).filter(function (el) { return el.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && d.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && d.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    list.addEventListener("click", function (e) {
      var s = e.target.closest("[data-sx-q]");
      if (s) { input.value = s.getAttribute("data-sx-q"); render(input.value); input.focus(); return; }
      var a = e.target.closest("a[data-sx-opt]");
      if (a) track("search_select", { term: input.value.trim(), type: a.getAttribute("data-type") || "" });
    });
    d.addEventListener("keydown", function (e) {
      var typing = /input|textarea|select/i.test((e.target.tagName || "")) || e.target.isContentEditable;
      if ((e.key === "k" || e.key === "K") && (e.metaKey || e.ctrlKey)) { e.preventDefault(); root.hidden ? open() : close(); }
      else if (e.key === "/" && !typing && root.hidden) { e.preventDefault(); open(); }
    });

    // Search results page: show homes, communities, guides and answers that Shopify's own search doesn't index.
    var pageBox = $("[data-sx-page]");
    if (pageBox) {
      var q0 = new URLSearchParams(w.location.search).get("q");
      if (q0) load().then(function () {
        var r = search(q0), html = "", homes = r.homes || (r.groups.r || []);
        var block = function (title, arr, n) {
          if (!arr || !arr.length) return;
          html += '<div class="sx-page__g"><h2>' + esc(title) + "</h2><div class=\"sx-page__list\">";
          arr.slice(0, n).forEach(function (it) { opts = []; html += row(it); });
          html += "</div></div>";
        };
        var faq = (r.groups.f || [])[0];
        if (faq && !parse(q0).tokens.every(function (t) { return tokenScore(faq, t) > 0; })) faq = null;
        if (faq) html += '<div class="sx-page__answer"><p class="label">' + esc(L.g_f) + '</p><p class="sx__q">' + esc(faq.n) + '</p><p>' + esc(faq.x) + "</p></div>";
        block(r.homes ? L.homes_match : L.g_r, homes, 6);
        block(L.g_c, r.groups.c, 4);
        block(L.g_g, r.groups.g, 4);
        pageBox.innerHTML = html.replace(/ role="option" id="sx-o\d+"/g, "");
      }).catch(function () {});
    }
  })();

  /* ---- Panama Notes sign-ups ---- */
  $$("form.nl__form").forEach(function (form) {
    form.addEventListener("submit", function () { track("newsletter_signup", { list: "panama-notes", form: form.id, page: w.location.pathname }); });
  });

  /* ---- Form confirmations after Shopify's redirect ----
     Shopify marks every form of the same type as posted, so only the form that was actually
     submitted keeps its confirmation or error; the others go back to their normal state. */
  (function () {
    var KEY = "chiq_last_form";
    $$("form").forEach(function (f) {
      f.addEventListener("submit", function () { try { w.sessionStorage.setItem(KEY, f.id || ""); } catch (e) {} });
    });
    var states = $$("form").filter(function (f) { return f.querySelector("[data-posted-ok],[data-posted-err]"); });
    if (!states.length) return;
    var last = ""; try { last = w.sessionStorage.getItem(KEY) || ""; w.sessionStorage.removeItem(KEY); } catch (e) {}
    var hash = decodeURIComponent(w.location.hash.slice(1));
    var target = states.filter(function (f) { return f.id && (f.id === hash || f.id === last); })[0] || (states.length === 1 ? states[0] : null);
    states.forEach(function (f) {
      if (!target || f === target) return;
      $$("[data-posted-ok],[data-posted-err]", f).forEach(function (m) { m.hidden = true; });
      $$("[data-fields]", f).forEach(function (el) { el.hidden = false; });
    });
    if (target) {
      var msg = target.querySelector("[data-posted-ok]:not([hidden])") || target.querySelector("[data-posted-err]");
      if (msg) {
        msg.scrollIntoView({ block: "center" }); msg.focus({ preventScroll: true });
        if (msg.hasAttribute("data-posted-ok")) track("form_success", { form: target.id, page: w.location.pathname });
      }
    }
    if (/[?&](contact|customer)_posted=/.test(w.location.search) && w.history.replaceState) {
      var q = w.location.search.replace(/([?&])(contact|customer)_posted=[^&]*&?/g, "$1").replace(/[?&]$/, "");
      w.history.replaceState(null, "", w.location.pathname + q);
    }
  })();
  $$("[data-form-again]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var f = btn.closest("form"), ok = btn.closest("[data-posted-ok]"), fields = f && f.querySelector("[data-fields]");
      if (ok) ok.hidden = true;
      if (fields) { fields.hidden = false; var first = fields.querySelector("input:not([type=hidden]),select,textarea"); if (first) first.focus(); }
    });
  });

  /* ---- Residence filters: collapsible on small screens ---- */
  $$("[data-filters-toggle]").forEach(function (btn) {
    var form = btn.closest("form");
    btn.addEventListener("click", function () {
      var open = btn.getAttribute("aria-expanded") !== "true";
      btn.setAttribute("aria-expanded", String(open)); form.classList.toggle("is-open", open);
    });
    // open automatically when the page was loaded with active filters
    if (/[?&](max|beds|system|status)=(?!all)/.test(w.location.search)) { btn.setAttribute("aria-expanded", "true"); form.classList.add("is-open"); }
  });

  /* ---- Language switcher (Shopify localization form) ---- */
  $$("[data-locale-switch]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var form = btn.closest("form"); if (!form) return;
      var input = $("input[name='locale_code']", form); if (input) input.value = btn.value;
      track("language_switch", { to: btn.value });
      form.submit();
    });
  });

  /* ---- Reveal on scroll ---- */
  var rev = $$("[data-reveal]");
  if (reduced || !("IntersectionObserver" in w)) rev.forEach(function (e) { e.classList.add("is-in"); });
  else {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -8% 0px" });
    rev.forEach(function (e) { io.observe(e); });
  }

  /* ---- Residence filtering (cards are server-rendered; this only hides/shows them) ---- */
  $$("[data-residence-filter]").forEach(function (root) {
    var form = $("form", root), cards = $$("[data-card]", root), count = $("[data-count]", root), empty = $("[data-empty]", root);
    if (!form) return;
    var controls = $$("select,input", form);
    var reset = $("[data-reset]", root), more = $(".filters__more", form);
    var params = new URLSearchParams(w.location.search);
    controls.forEach(function (c) {
      if (!params.has(c.name)) return;
      if (c.type === "radio") c.checked = c.value === params.get(c.name); else c.value = params.get(c.name);
    });
    if (more && (params.has("system") || params.has("status"))) more.open = true;
    var tpl = count ? count.getAttribute("data-template") || "[count]" : "";
    function read() {
      var f = {};
      controls.forEach(function (c) { if (c.type === "radio" && !c.checked) return; f[c.name] = c.value; });
      return f;
    }
    function apply(push) {
      var f = read(), n = 0, active = false;
      Object.keys(f).forEach(function (k) { if (f[k] && f[k] !== "all") active = true; });
      cards.forEach(function (card) {
        var ds = card.dataset, ok = true;
        if (f.life && f.life !== "all" && ds.life !== f.life) ok = false;
        if (f.community && f.community !== "all" && ds.community !== f.community) ok = false;
        if (f.system && f.system !== "all" && ds.system !== f.system) ok = false;
        if (f.beds && f.beds !== "all" && (+ds.beds || 0) < +f.beds) ok = false;
        if (f.max && f.max !== "all" && (!+ds.price || +ds.price > +f.max)) ok = false;
        if (f.status && f.status !== "all" && ds.status !== f.status) ok = false;
        card.hidden = !ok; if (ok) n++;
      });
      if (count) count.textContent = tpl.replace("[count]", n);
      if (empty) empty.hidden = n !== 0;
      if (reset) reset.hidden = !active;
      if (push) {
        var p = new URLSearchParams();
        Object.keys(f).forEach(function (k) { if (f[k] && f[k] !== "all") p.set(k, f[k]); });
        var qs = p.toString();
        w.history.replaceState(null, "", w.location.pathname + (qs ? "?" + qs : "") + w.location.hash);
        track("filter", f);
      }
    }
    controls.forEach(function (c) { c.addEventListener("change", function () { apply(true); }); });
    if (reset) reset.addEventListener("click", function () {
      controls.forEach(function (c) { if (c.type === "radio") c.checked = c.value === "all"; else c.value = "all"; });
      apply(true);
    });
    form.addEventListener("submit", function (e) { e.preventDefault(); apply(true); });
    apply(false);
  });

  /* ---- Lightbox (gallery + floor plans) ---- */
  var lb = null, items = [], idx = 0, opener = null;
  function buildLb() {
    lb = d.createElement("div");
    lb.className = "lb"; lb.setAttribute("role", "dialog"); lb.setAttribute("aria-modal", "true");
    lb.setAttribute("aria-label", (d.documentElement.lang || "en").indexOf("es") === 0 ? "Visor de imágenes" : "Image viewer");
    lb.innerHTML = '<div class="lb__top"><span data-lb-count></span><button type="button" data-lb-close aria-label="Close">✕</button></div>' +
      '<div class="lb__stage"><img alt=""></div><p class="lb__cap" data-lb-cap></p>' +
      '<button type="button" class="lb__prev" data-lb-prev aria-label="Previous">‹</button><button type="button" class="lb__next" data-lb-next aria-label="Next">›</button>';
    d.body.appendChild(lb);
    $("[data-lb-close]", lb).addEventListener("click", closeLb);
    $("[data-lb-prev]", lb).addEventListener("click", function () { show(idx - 1); });
    $("[data-lb-next]", lb).addEventListener("click", function () { show(idx + 1); });
    lb.addEventListener("click", function (e) { if (e.target === lb || e.target.classList.contains("lb__stage")) closeLb(); });
    lb.addEventListener("keydown", function (e) {
      if (e.key === "Escape") closeLb();
      if (e.key === "ArrowRight") show(idx + 1);
      if (e.key === "ArrowLeft") show(idx - 1);
      if (e.key === "Tab") { var f = $$("button", lb); var first = f[0], last = f[f.length - 1]; if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); } else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); } }
    });
  }
  function show(i) {
    idx = (i + items.length) % items.length;
    var it = items[idx], img = $(".lb__stage img", lb);
    img.src = it.src; img.alt = it.alt || "";
    $("[data-lb-cap]", lb).textContent = it.alt || "";
    $("[data-lb-count]", lb).textContent = (idx + 1) + " / " + items.length;
    var multi = items.length > 1; $("[data-lb-prev]", lb).hidden = !multi; $("[data-lb-next]", lb).hidden = !multi;
  }
  function openLb(group, start, from) {
    if (!lb) buildLb();
    items = $$("[data-lb-item][data-group='" + group + "']").map(function (el) { return { src: el.getAttribute("data-full"), alt: el.getAttribute("data-alt") }; });
    if (!items.length) return;
    opener = from; lb.setAttribute("open", ""); d.body.style.overflow = "hidden";
    show(start); $("[data-lb-close]", lb).focus();
    track("gallery_open", { group: group });
  }
  function closeLb() { if (!lb) return; lb.removeAttribute("open"); d.body.style.overflow = ""; if (opener) opener.focus(); }
  d.addEventListener("click", function (e) {
    var t = e.target.closest("[data-lb-open]"); if (!t) return;
    e.preventDefault();
    var group = t.getAttribute("data-group"), all = $$("[data-lb-item][data-group='" + group + "']");
    var start = Math.max(0, all.indexOf(t.closest("[data-lb-item]") || t));
    openLb(group, t.hasAttribute("data-start") ? +t.getAttribute("data-start") : start, t);
  });

  /* ---- Share with broker / download overview ---- */
  d.addEventListener("click", function (e) {
    var s = e.target.closest("[data-share]");
    if (s) {
      e.preventDefault();
      var url = s.getAttribute("data-url") || w.location.href, title = s.getAttribute("data-title") || d.title;
      track("share_broker", { residence: s.getAttribute("data-residence") || "", method: navigator.share ? "native" : "copy" });
      if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
      var done = function () { var o = s.textContent; s.textContent = s.getAttribute("data-copied") || "Link copied"; setTimeout(function () { s.textContent = o; }, 2200); };
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, function () { w.location.href = "mailto:?subject=" + encodeURIComponent(title) + "&body=" + encodeURIComponent(url); });
      else w.location.href = "mailto:?subject=" + encodeURIComponent(title) + "&body=" + encodeURIComponent(url);
      return;
    }
    var o = e.target.closest("[data-overview]");
    if (o) {
      track("download_overview", { residence: o.getAttribute("data-residence") || "", type: o.getAttribute("href") ? "pdf" : "print" });
      if (!o.getAttribute("href")) { e.preventDefault(); w.print(); }
      return;
    }
    var wa = e.target.closest("[data-whatsapp]");
    if (wa) track("whatsapp_click", { page: w.location.pathname, location: wa.getAttribute("data-whatsapp") || "", residence: ctx.residence || "" });
    var tel = e.target.closest("a[href^='tel:'],a[href^='mailto:']");
    if (tel) track("contact_click", { type: tel.getAttribute("href").split(":")[0] });
  });

  /* ---- Map: click to load (no third-party request until the visitor asks) ---- */
  $$("[data-map-load]").forEach(function (b) {
    b.addEventListener("click", function () {
      var box = b.closest("[data-map]"), f = d.createElement("iframe");
      f.src = box.getAttribute("data-src"); f.title = box.getAttribute("data-title") || "Map"; f.loading = "lazy"; f.referrerPolicy = "no-referrer-when-downgrade";
      box.innerHTML = ""; box.appendChild(f); track("map_open", { title: f.title });
    });
  });

  /* ---- Enquiry forms: attribution + optional lead endpoint ---- */
  function store(k, v) { try { if (v) sessionStorage.setItem(k, v); return sessionStorage.getItem(k) || ""; } catch (e) { return v || ""; } }
  var qs = new URLSearchParams(w.location.search);
  var attrib = {
    utm_source: store("chiq_utm_source", qs.get("utm_source")),
    utm_medium: store("chiq_utm_medium", qs.get("utm_medium")),
    utm_campaign: store("chiq_utm_campaign", qs.get("utm_campaign")),
    utm_term: store("chiq_utm_term", qs.get("utm_term")),
    utm_content: store("chiq_utm_content", qs.get("utm_content")),
    referrer: store("chiq_referrer", d.referrer && d.referrer.indexOf(w.location.host) === -1 ? d.referrer : ""),
    broker_ref: store("chiq_broker", qs.get("broker") || qs.get("ref"))
  };
  $$(".enq form").forEach(function (form) {
    var wrap = form.closest(".enq");
    var set = function (name, val) { var el = form.querySelector("[name='contact[" + name + "]']"); if (el && !el.value) el.value = val || ""; };
    set("page_url", w.location.href.split("#")[0]);
    set("language", d.documentElement.lang || "");
    Object.keys(attrib).forEach(function (k) { if (k !== "broker_ref") set(k, attrib[k]); });
    var broker = form.querySelector("[name='contact[broker]']"); if (broker && !broker.value && attrib.broker_ref) broker.value = attrib.broker_ref;
    var goals = $$("[name='contact[goal]']", form), subj = form.querySelector("[name='contact[subject]']");
    var syncSubject = function () {
      var g = goals.filter(function (r) { return r.checked; })[0];
      if (subj) subj.value = (wrap.getAttribute("data-subject") || "Enquiry") + (g ? " — " + (g.getAttribute("data-label") || g.value) : "");
    };
    goals.forEach(function (r) { r.addEventListener("change", syncSubject); }); syncSubject();
    // preset goal from ?goal=video-call etc.
    var pre = qs.get("goal"); if (pre) goals.forEach(function (r) { if (r.value === pre) { r.checked = true; syncSubject(); } });

    var endpoint = wrap.getAttribute("data-endpoint") || "";
    form.addEventListener("submit", function (e) {
      var consent = form.querySelector("[name='contact[consent]']");
      if (consent && !consent.checked) { e.preventDefault(); consent.focus(); consent.setAttribute("aria-invalid", "true"); return; }
      var payload = {}; new FormData(form).forEach(function (v, k) { var m = k.match(/^contact\[(.+)\]$/); if (m) payload[m[1]] = v; });
      track("enquiry_submit", { goal: payload.goal || "", residence: payload.residence_id || "", community: payload.community || "", source: payload.form_source || "" });
      if (!endpoint) return; // native Shopify contact form handles it
      e.preventDefault();
      var btn = form.querySelector("[type=submit]"); if (btn) btn.disabled = true;
      var ts = form.querySelector("[name='cf-turnstile-response']"); if (ts) payload.turnstile = ts.value;
      payload.hp = (form.querySelector("[name='contact[website]']") || {}).value || "";
      fetch(endpoint, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) })
        .then(function (r) { return r.json().catch(function () { return {}; }).then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.j && res.j.error || "failed");
          var ok = wrap.querySelector("[data-form-ok]");
          form.hidden = true; if (ok) { ok.hidden = false; ok.focus(); }
        })
        .catch(function () {
          // fall back to Shopify's own contact form so no enquiry is lost
          endpoint = null; if (btn) btn.disabled = false; HTMLFormElement.prototype.submit.call(form);
        });
    });
  });

  /* ---------- External links in editorial content open in a new tab ---------- */
  $$(".prose a[href^='http'], .rte a[href^='http']").forEach(function (a) {
    try { if (new URL(a.href).host === location.host) return; } catch (e) { return; }
    if (!a.target) a.target = "_blank";
    var rel = (a.getAttribute("rel") || "").split(/\s+/);
    if (rel.indexOf("noopener") < 0) { rel.push("noopener"); a.setAttribute("rel", rel.join(" ").trim()); }
  });
})();
